module.exports = __webpack_public_path__ + "img/card-bg-deco-no-value-dark.806052e2.png";